import styled from 'styled-components';
import tw from 'tailwind.macro';
import Banner from './Banner';
import Header from './Header';

const Container = styled.div`
  ${tw`relative`}

  @media (min-width: 992px) {
    &:before {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(34, 227, 170, 0.2) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      left: -348px;
      top: -589px;
      border-radius: 0px;
      bottom: 0;
    }
  }
`;

const Destinations = () => (
  <Container>
    <Header />
    <Banner />
  </Container>
);

export default Destinations;
